import React, { useState } from 'react';
import axios from 'axios';

const ItemCard = ({ item }) => {
  const [ownerInfo, setOwnerInfo] = useState(null);

  const handleOwnerClick = async () => {
    try {
      const response = await axios.get(`https://backend-alien.vercel.app/api/auth/getuser/${item.owner}`);
      setOwnerInfo(response.data);
    } catch (error) {
      console.error('Error fetching owner info:', error.message);
    }
  };

  const handleClosePopup = () => {
    setOwnerInfo(null);
  };

  return (
    <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow relative">
      <img className="h-40 w-full object-cover mb-4 rounded-lg" src={item.imageUrl} alt={item.title} />
      <div>
        <a href="/">
          <h5 className="mb-2 text-xl font-bold tracking-tight text-gray-900">{item.title}</h5>
        </a>
        <p className="mb-3 font-normal text-gray-700">{item.description}</p>
        <div className="flex justify-between mb-2">
          <span className="text-gray-800 font-semibold">Price:</span>
          <span className="text-gray-600">${item.price}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="text-gray-800 font-semibold">Condition:</span>
          <span className="text-gray-600">{item.condition}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="text-gray-800 font-semibold">Status:</span>
          <span className="text-gray-600">{item.status}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span className="text-gray-800 font-semibold">Owner Name:</span>
          <span className="text-gray-600">{item.ownerName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-800 font-semibold">Location:</span>
          <span className="text-gray-600">{item.location}</span>
        </div>
        <button
          onClick={handleOwnerClick}
          className="mt-4 px-4 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
        >
          View Owner Details
        </button>
      </div>
      {ownerInfo && (
        <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-50">
          <div className="bg-white p-8 max-w-md rounded-lg">
            <button onClick={handleClosePopup} style={{color:"white"}} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 focus:outline-none">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h2 className="text-2xl font-bold mb-4">Owner Details</h2>
            <p><span className="font-semibold">Name:</span> {ownerInfo.name}</p>
            <p><span className="font-semibold">Email:</span> {ownerInfo.email}</p>
            <p><span className="font-semibold">Phone Number:</span> {ownerInfo.phoneNumber}</p>
            <p><span className="font-semibold">Student ID:</span> {ownerInfo.studentId}</p>
            <p><span className="font-semibold">Hostel Room No:</span> {ownerInfo.hostelRoomNo}</p>
            <p><span className="font-semibold">Hostel Building No:</span> {ownerInfo.hostelBuildingNo}</p>
            <a href={`mailto:${ownerInfo.email}`} className="mt-4 inline-block px-4 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300">
              Contact Owner
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemCard;
